import React from 'react';
import { Text, View, Image } from '@react-pdf/renderer';

import Logo from '../../assets/logo.png'

const Footer = () => {
  return (
    <View style={{
      fontSize: 9,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Text>Généré par </Text>
      <Image src={Logo} style={{ width: 35 }}/>
    </View>
  )
}

export default Footer
